import { styled, Text, spacing, mq } from '@thg-commerce/gravity-theme'
import { GridItem } from '@thg-commerce/gravity-system'
import { Image, Button, Separator } from '@thg-commerce/gravity-elements'
import { PageWrapper } from '@thg-commerce/enterprise-core'

export const StyledGrid = styled(PageWrapper)`
  margin: 0 auto 0;
  margin-top: ${spacing(3)};
  max-width: ${(props) => props.theme.site.siteWidth};
`

export const StyledGridItem = styled(GridItem)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    margin-left: ${spacing(2)};
    margin-right: ${spacing(2)};
  }
`

export const ImageGridItem = styled(GridItem)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-left: ${spacing(2)};
  }
`

export const SeparatorGridItem = styled(GridItem)`
  margin-left: ${spacing(2)};
  margin-right: ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(3)};
  }
`

export const StyledSeparator = styled(Separator)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    margin-top: ${spacing(3)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(4)};
  }
`

export const BottomSeparatorGridItem = styled(GridItem)`
  margin: ${spacing(4)} ${spacing(2)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(6)};
  }
`

export const Title = styled.h1`
  ${Text('large2', 'alternate')};
`

export const Subtitle = styled.h2`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(2)};
`

export const ErrorText = styled.p`
  ${Text('medium1', 'default')};
  margin-bottom: ${spacing(2)};
`

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  min-width: 146px;

  &:hover {
    cursor: pointer;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 343px;
    height: 49px;
  }
`
